/* eslint-disable */
export default {
  noRecords: 'Nessun record recente corrispondente.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
